import { useState, useEffect } from "react";
import { X, Check, Copy } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { BRAND } from "@/lib/brand";
import { toast } from "sonner";

export default function EmailPopup() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("ape_popup_seen")) return;
    const t = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(t);
  }, []);

  const close = () => { setShow(false); localStorage.setItem("ape_popup_seen", "1"); };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/subscribe", { email });
      setDone(true);
      localStorage.setItem("ape_popup_seen", "1");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-testid="email-popup">
      <div className="relative w-full max-w-md bg-ape-surface border border-ape-border overflow-hidden">
        <div className="h-1.5 w-full bg-ape-red" />
        <button onClick={close} data-testid="popup-close" className="absolute top-3 right-3 text-ape-muted hover:text-white transition-colors duration-150"><X size={22} /></button>

        <div className="p-8 text-center">
          <img src={BRAND.logoCircle} alt="APE-TIDES" className="h-16 w-16 object-contain mx-auto mb-4" />
          {done ? (
            <div data-testid="popup-success">
              <Check className="mx-auto text-ape-red mb-3" size={40} />
              <h2 className="font-display text-3xl tracking-tight">YOU'RE IN, BEAST</h2>
              <p className="text-ape-muted mt-3 text-sm">Here's your 10% off code. Use it at checkout:</p>
              <div className="mt-4 flex items-center justify-center gap-3 border-2 border-ape-red bg-ape-red/10 py-4">
                <span className="font-display text-4xl tracking-[0.2em] text-ape-red" data-testid="popup-code">APE10</span>
                <button onClick={() => { navigator.clipboard.writeText("APE10"); toast.success("Code copied!"); }} className="text-ape-muted hover:text-ape-red transition-colors duration-150"><Copy size={18} /></button>
              </div>
              <button onClick={close} className="mt-6 w-full bg-ape-red hover:bg-ape-redhover text-white font-head uppercase tracking-widest py-3.5 transition-colors duration-150" data-testid="popup-shop">Start Shopping</button>
            </div>
          ) : (
            <>
              <span className="font-mono2 text-xs tracking-[0.3em] text-ape-red">UNLOCK 10% OFF</span>
              <h2 className="font-display text-4xl tracking-tight mt-2 leading-none">EVOLVE BEYOND<br /><span className="text-ape-red">LIMITS.</span></h2>
              <p className="text-ape-muted mt-3 text-sm">Drop your email and get <span className="text-white font-semibold">10% off</span> your first order of premium research peptides.</p>
              <form onSubmit={submit} className="mt-6 space-y-3" data-testid="popup-form">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" data-testid="popup-email"
                  className="w-full bg-ape-bg border-2 border-ape-border rounded-none px-4 py-3 text-white text-center focus:border-ape-red focus:outline-none transition-colors duration-150" />
                <button disabled={loading} className="w-full bg-ape-red hover:bg-ape-redhover disabled:opacity-50 text-white font-head uppercase tracking-widest py-3.5 transition-colors duration-150" data-testid="popup-submit">
                  {loading ? "…" : "Get My 10% Code"}
                </button>
              </form>
              <button onClick={close} className="mt-3 font-mono2 text-[10px] tracking-widest text-ape-muted hover:text-white transition-colors duration-150" data-testid="popup-dismiss">NO THANKS, I PAY FULL PRICE</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
